var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddCardBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_15367_16178",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 36,
    height: 36
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_15367_16178)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.875 28.125H25.5C25.1812 28.125 24.9141 28.0171 24.6986 27.8014C24.4829 27.5856 24.375 27.3184 24.375 26.9996C24.375 26.6806 24.4829 26.4135 24.6986 26.1982C24.9141 25.9827 25.1812 25.875 25.5 25.875H28.875V22.5C28.875 22.1812 28.9829 21.9141 29.1986 21.6986C29.4144 21.4829 29.6816 21.375 30.0004 21.375C30.3194 21.375 30.5865 21.4829 30.8018 21.6986C31.0173 21.9141 31.125 22.1812 31.125 22.5V25.875H34.5C34.8188 25.875 35.0859 25.9829 35.3014 26.1986C35.5171 26.4144 35.625 26.6816 35.625 27.0004C35.625 27.3194 35.5171 27.5865 35.3014 27.8018C35.0859 28.0173 34.8188 28.125 34.5 28.125H31.125V31.5C31.125 31.8188 31.0171 32.0859 30.8014 32.3014C30.5856 32.5171 30.3184 32.625 29.9996 32.625C29.6806 32.625 29.4135 32.5171 29.1982 32.3014C28.9827 32.0859 28.875 31.8188 28.875 31.5V28.125ZM6 17.394H30V12.606H6V17.394ZM6.46163 29.25C5.70387 29.25 5.0625 28.9875 4.5375 28.4625C4.0125 27.9375 3.75 27.2961 3.75 26.5384V9.46163C3.75 8.70387 4.0125 8.0625 4.5375 7.5375C5.0625 7.0125 5.70387 6.75 6.46163 6.75H29.5384C30.2961 6.75 30.9375 7.0125 31.4625 7.5375C31.9875 8.0625 32.25 8.70387 32.25 9.46163V17.0194C32.25 17.4034 32.12 17.7254 31.86 17.9854C31.6003 18.2451 31.2783 18.375 30.894 18.375H28.875C26.8 18.375 25.0312 19.1063 23.5688 20.5688C22.1063 22.0313 21.375 23.8 21.375 25.875V27.894C21.375 28.2782 21.2451 28.6003 20.9854 28.86C20.7254 29.12 20.4034 29.25 20.0194 29.25H6.46163Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCardBlack);
export default __webpack_public_path__ + "static/media/add_card_black.9ae56445a4feaaff8da5f54ed6ddbe5f.svg";
export { ForwardRef as ReactComponent };